import React from 'react';
import styled from 'styled-components/macro';
import { ButtonInvertedLink } from '../../../UI/Button/Button';
import AbcLogo from '../../../../assets/images/AbcLogo.png';

const Background = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #4f605e;
  /* background: #627170; */
  /* background: #3B4E4C; */
  /* background: #283D3B; */
  /* background: #348AA7; */
  height: 360px;
  width: 100%;
`;

const TextMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.div`
  margin: 16px 0 8px;
  color: #fff;
  font-family: miller-display, serif;
  font-weight: 600;
  font-style: normal;
  font-size: 32px;
  width: 100%;
`;

const SubTitle = styled.div`
  width: 100%;
  color: #fff;
  font-family: Lato;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
`;

const ButtonWrapper = styled.div`
  text-align: center;
  margin-bottom: 16px;
  width: 100%;
`;

const PreviewImgWrapper = styled.div`
  height: 210px;
`;

const BackgroundDesktop = styled(Background)`
  flex-direction: row;
  justify-content: center;
  height: 500px;
`;

const PreviewWrapperDesktop = styled.div`
  display: flex;
  justify-content: space-between;
  width: 700px;
  height: 300px;
`;

const TextAndButtonDesktop = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TextDesktop = styled.div`
  display: flex;
  flex-direction: column;
`;
const TitleDesktop = styled(Title)`
  margin: 16px 0 12px;
  text-align: left;
`;

const SubTitleDesktop = styled(SubTitle)`
  font-weight: 400;
  text-align: left;
  line-height: 23px;
  width: 310px;
`;

const ButtonWrapperDesktop = styled.div`
  display: flex;
`;

const PreviewImgWrapperDesktop = styled.div`
  height: 300px;
`;

const PreviewImg = styled.img`
  height: 20%;
  width: auto;
  margin-top: ${(props) => props.mobMargin};
  background: ${(props) => props.color};
`;

const PreviewMobile = (props) => (
  <Background>
    <TextMobile>
      <Title>abcfinlab</Title>
      <SubTitle>Rethinking digital banking products</SubTitle>
    </TextMobile>
    <PreviewImgWrapper>
      <PreviewImg
        mobMargin={'46px'}
        src={AbcLogo}
        alt="abcfinlabLogo"
      ></PreviewImg>
    </PreviewImgWrapper>
    <ButtonWrapper>
      <ButtonInvertedLink exact="true" to="/work/abcfinlab">
        Read More
      </ButtonInvertedLink>
    </ButtonWrapper>
  </Background>
);

const PreviewDesktop = (props) => (
  <BackgroundDesktop>
    <PreviewWrapperDesktop>
      <TextAndButtonDesktop>
        <TextDesktop>
          <TitleDesktop>abcfinlab</TitleDesktop>
          <SubTitleDesktop>
            Rethinking digital banking products <br />
            <br />
            As a FinTech startup subsidiary of the Werhahn Group, abcfinlab is
            dedicated to the development of new digital ways in the field of
            leasing and factoring.
          </SubTitleDesktop>
        </TextDesktop>
        <ButtonWrapperDesktop>
          <ButtonInvertedLink exact="true" to="/work/abcfinlab">
            Read More
          </ButtonInvertedLink>
        </ButtonWrapperDesktop>
      </TextAndButtonDesktop>
      <PreviewImgWrapperDesktop>
        <PreviewImg
          mobMargin={'100px'}
          src={AbcLogo}
          alt="abcfinlabLogo"
        ></PreviewImg>
      </PreviewImgWrapperDesktop>
    </PreviewWrapperDesktop>
  </BackgroundDesktop>
);

const AbcPreview = (props) => {
  // const mq = window.matchMedia('(max-width: 400px)');

  return (
    <>
      {props.desktop ? <PreviewDesktop /> : <PreviewMobile />}
      {/* {isMobile && window.matchMedia('(max-width: 768px)').matches ? (
        <PreviewMobile />
      ) : (
        <PreviewDesktop />
      )} */}
    </>
    // <Background>
    //   {isMobile && document.documentElement.clientWidth < 400 ? (
    //     <PreviewMobile />
    //   ) : (
    //     <PreviewDesktop />
    //   )}
    // </Background>

    // <Background>
    //   {isMobile && mq.matches ? (
    //     <PreviewMobile />
    //   ) : (
    //     <PreviewDesktop />
    //   )}
    // </Background>
  );
};

export default AbcPreview;
